import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductMixtionService {

  constructor(
    private http: HttpClient
  ) { }

  getProductMixtions() {
    return this.http.get(`${environment.apiUrl}/mixtion-products`);
  }

  createProductMixtion(product: any) {
    return this.http.post(`${environment.apiUrl}/mixtion-products`, product);
  }
  
  getProductMixtionById(id: number) {
    return this.http.get(`${environment.apiUrl}/mixtion-products/${id}`);
  }

  updateProductMixtion(product: any) {
    return this.http.put(`${environment.apiUrl}/mixtion-products/${product.id}`, product);
  }


  deleteProductMixtion(id: number) {
    return this.http.delete(`${environment.apiUrl}/mixtion-products/${id}`);
  }

  uploadValidateProductMixtion(file: Blob) {
    const formData = new FormData();
    formData.append("file", file);

    return this.http.post(`${environment.apiUrl}/mixtion-products/upload-validate`, formData);
  }

  saveLoadProductMixtion(data: any) {
    return this.http.post(`${environment.apiUrl}/mixtion-products/save-load`, data);
  }
}
